import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-center"
      toastOptions={{
        // 3× bigger toasts: increased padding, font-size, min-height, icon size
        style: {
          fontSize: "18px",
          padding: "20px 24px",
          minHeight: "72px",
          minWidth: "360px",
          maxWidth: "560px",
          borderWidth: "2px",
          borderRadius: "16px",
          boxShadow: "0 10px 40px -5px rgba(0,0,0,0.25)",
          fontWeight: "600",
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-2xl text-base sm:text-lg",
          title: "text-base sm:text-lg font-bold",
          description: "group-[.toast]:text-muted-foreground text-sm sm:text-base",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground text-base px-4 py-2",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground text-base px-4 py-2",
          success: "group-[.toaster]:!bg-green-50 group-[.toaster]:!text-green-900 group-[.toaster]:!border-green-400",
          error: "group-[.toaster]:!bg-red-50 group-[.toaster]:!text-red-900 group-[.toaster]:!border-red-400",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
